import React, { useState, useEffect } from 'react';

// Component Imports
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ProcessSection from './components/ProcessSection';
import PricingSection from './components/PricingSection';
import FeaturesSection from './components/FeaturesSection';
import CompaniesSection from './components/CompaniesSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';

const App = () => {
  const [activeSection, setActiveSection] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [showFloatingNav, setShowFloatingNav] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    setIsVisible(true);
    
    const handleScroll = () => {
      setShowFloatingNav(window.scrollY > 100);
      
      const sections = ['section-0', 'section-1', 'section-2', 'section-3', 'section-4'];
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      
      sections.forEach((sectionId, index) => {
        const element = document.getElementById(sectionId);
        if (element) {
          const elementTop = element.offsetTop;
          const elementBottom = elementTop + element.offsetHeight;
          
          if (scrollPosition >= elementTop && scrollPosition <= elementBottom) {
            setActiveSection(index);
          }
        }
      });
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % 4);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const handleStepClick = (index) => {
    setActiveStep(index);
    setIsAutoPlaying(false);
    
    setTimeout(() => {
      setIsAutoPlaying(true);
    }, 10000);
  };

  const scrollToSection = (index) => {
    setActiveSection(index);
    const element = document.getElementById(`section-${index}`);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="font-['Inter',sans-serif] bg-white">
      <Navigation 
        showFloatingNav={showFloatingNav} 
        activeSection={activeSection} 
        scrollToSection={scrollToSection} 
      />
      
      <HeroSection 
        isVisible={isVisible} 
        scrollToSection={scrollToSection} 
      />
      
      <ProcessSection 
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        isAutoPlaying={isAutoPlaying}
        handleStepClick={handleStepClick}
      />
      
      <PricingSection />
      
      <FeaturesSection isVisible={isVisible} />
      
      <CompaniesSection />
      
      <AboutSection />
      
      <Footer />
      
      <WhatsAppFloat />
      {/* <LiveChat /> */}

      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }

        @keyframes gradientShift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
      `}</style>
    </div>
  );
};

export default App;